// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"931":"ee7edb50","943":"58cdf37e","946":"58cdf37e","993":"ee7edb50"}[chunkId] + ".chunk.css";
};